import React from 'react';

import TextField from '@material-ui/core/TextField';
import inputCtor from '../../utils/inputCtor';

import LabelDisplay from '../LabelDisplay';
import HelperText from '../HelperText';

import handleChanges from '../../utils/handleChanges';

const Input = ({
 id,
 name,
 type,
 onChange,
 onChangeHandlers,
 endAdornment,
 value,
 disabled,
}) => (
  <TextField
    id={id ? `${id}Input` : ''}
    name={name}
    type={type || 'text'}
    onChange={handleChanges({name, onChange, onChangeHandlers})}
    value={value || ''}
    disabled={disabled}
    margin="none"
    variant="standard"
    InputProps={{
      disableUnderline: true,
      endAdornment
    }}
  />
);

const Component = ({
 className,
 labelProps,
 inputProps,
 errorProps
}) => {
  return (
    <div
      id={inputProps.id}
      className={[
        'merchant-field',
        'merchant-input',
        inputProps.disabled ? ' disabled' : '',
        errorProps.showError ? ' error' : '',
        className
      ].join(' ')}
    >
      <LabelDisplay {...labelProps} />
      <Input {...inputProps} />
      <HelperText {...errorProps} />
    </div>
  )
}

export default inputCtor(Component);
